import * as UI     from '../ui';
import { connect } from 'react-redux';
import React       from 'react';


class Toast extends React.PureComponent {
  constructor(props) {
    super(props);

    this.showToastIfNeeded = this.showToastIfNeeded.bind(this);
  }

  componentDidMount() {
    this.$f7ready(this.showToastIfNeeded);
  }

  componentDidUpdate() {
    this.$f7ready(this.showToastIfNeeded);
  }

  showToastIfNeeded(app) {
    const { text } = this.props;

    if (text) {
      app.toast.create({
        text,
        closeTimeout: 3000
      }).open();

      this.props.cleanToast();
    }
  }

  render() {
    return null;
  }
}

export default connect(
  state => ({
    text: UI.getToast(state)
  }),
  dispatch => ({
    cleanToast: () => dispatch(UI.toast(null))
  })
)(Toast);
